module.exports = __webpack_public_path__ + "static/img/loginbg.e393ba9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginbg.png
// module id = OBOK
// module chunks = 3